<div class="container mt-4">
    <div class="col-lg-8 col-md-6 col-sm-12">
  <h1>Privacy Policy</h1>

  <p>
    At Skybeth Crochet, we respect your privacy and are committed to protecting your personal information.
  </p>

  <h3><b>Information We Collect</b></h3>
    <li>We may collect personal information such as your:</li>
    <li>Name</li>
    <li>Email Address</li>
    <li>Shipping and billing address</li>
    <li>Phone number (if provided)</li>
    <li>Payment information processed through secure third-party payment providers.</li> <br>
  <h3>How We Use Information</h3>
  <p>
    We use your information to:
  </p>
    <li>Process and fulfill orders</li>
    <li>Provide customer support</li>
    <li>Send order updates</li>
    <li>Improve our products and services</li>
    <li>Comply with legal obligations</li><br>
   <h3><b>Information Sharing</b></h3>
   <p>We do not sell or rent your personal information. Information may be shared only with trusted service providers such as payment processors and shipping carriers as necessary to complete your order.</p>
   <h3><b>Data Security</b></h3>
   <p>We take reasonable measures to protect your information. However, no online transmission or storage method is completely secure.</p>
  <h3><b>Contact Us</b></h3>
  <p>
    If you have any questions about this Privacy Policy, please contact us.
    <li>Email: Skybeth2026@gmail.com</li>
  </p>
  </div>
</div>
